:host{display:flex;flex-direction:column;height:100%}
/*# sourceMappingURL=admin-panel-user-package-list.component-UVHYOKAR.css.map */
